import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=e198ff04&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"
import style0 from "./Files.vue?vue&type=style&index=0&id=e198ff04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e198ff04",
  null
  
)

export default component.exports